import { useEffect, useState } from 'react'

import { sessionUpdateLastReadAt } from '@/httpRequest/modules/mesperyIm/sessionUpdateLastReadAt'
import { useMessageAtom } from '@/pages/MesperyIM/store/message'
import { isClickInsideElement } from '@/utils'

import { Chatbox } from './chatbox/Chatbox'
import { ContactsModal } from './contacts/ContactsModal'
import { ChaModalContext } from './context'
import { CreateGroup } from './goup/CreateGroup'
import styles from './message.module.less'

export const MesperyIM = () => {
  const {
    messageModalVisible,
    chatModalVisible,
    createCroupVisible,
    currentConversation,
    setGroupManage,
    groupManageVisible,
    setShowAddGroupMembers,
    setShowDropGroupMembers,
    setCurrentConversation,
    conversationList,
    setConversationList,
    messageData,
    setMessageData
  } = useMessageAtom()

  const [showChatModal, setShowChatModal] = useState(false)

  const onClickPanel = (event: React.MouseEvent<HTMLDivElement>) => {
    const targetElement = document.getElementById('groupManageEle')
    if (targetElement && isClickInsideElement(targetElement, event)) {
      console.log('点击发生在目标元素内部')
      return
    } else if (groupManageVisible) {
      setGroupManage(false)
    }
  }

  const handleUpdateLastReadAt = (last_read_at: number) => {
    sessionUpdateLastReadAt({
      last_read_at: last_read_at,
      session_id: currentConversation?.session_id || '',
      session_type: currentConversation?.session_type || 0
    })
    const sessionList = conversationList?.map((item) => {
      if (item.session_id === currentConversation?.session_id) {
        item.last_read_at = last_read_at
      }
      return item
    })
    setConversationList(sessionList)
  }

  useEffect(() => {
    setShowChatModal(chatModalVisible)
    setShowAddGroupMembers(false)
    setShowDropGroupMembers(false)
  }, [currentConversation])

  return (
    <ChaModalContext.Provider
      value={{
        onClose: () => {
          setMessageData({ list: [], next: false })
          setShowChatModal(false)
          setCurrentConversation(undefined)
          handleUpdateLastReadAt(
            Number(messageData?.list[messageData.list.length - 1]?.created_at)
          )
        }
      }}
    >
      {/* 背景半透明遮罩 */}
      <div
        className={styles.messageCover}
        style={{
          opacity: messageModalVisible ? 1 : 0,
          zIndex: messageModalVisible ? (createCroupVisible ? 700 : 600) : -1
        }}
        onClick={onClickPanel}
      ></div>

      {/* 通讯录 */}
      <ContactsModal />

      {/* 聊天框 */}
      {showChatModal && <Chatbox key={currentConversation?.session_id} />}

      {/* 创建群聊 */}
      {createCroupVisible && <CreateGroup />}
    </ChaModalContext.Provider>
  )
}
